const YOUTUBE_CLIENT_ID = process.env.REACT_APP_YOUTUBE_CLIENT_ID;
const API_URL = process.env.REACT_APP_API_URL;

/**
 * Get the normalized origin, stripping "www." to ensure consistent redirect URIs.
 */
const getNormalizedOrigin = () => {
  if (typeof window === 'undefined') return 'https://nexbii.com';
  const origin = window.location.origin;
  return origin.replace('://www.', '://');
};

const getRedirectUri = () => {
  if (process.env.REACT_APP_YOUTUBE_REDIRECT_URI) {
    return process.env.REACT_APP_YOUTUBE_REDIRECT_URI;
  }
  return `${getNormalizedOrigin()}/auth/youtube/callback`;
};

export const initiateYoutubeAuth = () => {
  if (!YOUTUBE_CLIENT_ID) {
    throw new Error('YouTube Client ID is not configured');
  }

  const redirectUri = getRedirectUri();
  const scope = 'https://www.googleapis.com/auth/youtube.readonly';
  const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');

  authUrl.searchParams.append('client_id', YOUTUBE_CLIENT_ID);
  authUrl.searchParams.append('redirect_uri', redirectUri);
  authUrl.searchParams.append('scope', scope);
  authUrl.searchParams.append('response_type', 'code');
  authUrl.searchParams.append('access_type', 'offline');

  const width = 600;
  const height = 700;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;

  return window.open(
    authUrl.toString(),
    'youtube-auth',
    `width=${width},height=${height},left=${left},top=${top}`,
  );
};

/**
 * Exchange YouTube authorization code for user data via backend API.
 * Sends redirect_uri so backend uses the same one during token exchange.
 */
export const getYoutubeAccessToken = async (code: string) => {
  const response = await fetch(`${API_URL}/api/auth/youtube/callback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ code, redirect_uri: getRedirectUri() }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`YouTube authentication failed: ${response.status} - ${text}`);
  }

  return response.json();
};
